import React from 'react';
import ErrorStyles from './Error.module.css';

const NetworkError = () => {
	return (
		<div className={ErrorStyles.errorContainer}>
			<svg>
				<use xlinkHref={`/assets/sprite.svg#icon-warning`} data-testid='error-icon' />
			</svg>
			<h1>Error</h1>
			<p>Something went wrong. Try again after some time.</p>
		</div>
	);
};

export default NetworkError;
